import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from "react-router-dom";
import "./style.less";
import { Animated } from 'react-animated-css';
import { AiOutlineRight } from "react-icons/ai";


const DropDown = (props) => {
  const {productList} = props
      const [showChild, setShowChild] = useState(-1)
      useEffect(() => {
      }, [])

  return (
    <div className="drop">
      <div className="items">
        {productList.map((val,index) => {
          return (
            <div className="product_classfiy" onMouseEnter={()=>{
              setShowChild(index)
            }} onMouseLeave={()=>{setShowChild(-1)}}>
              <div className="title">
                <Link to={val.path}>{val.title}</Link>
                {val.list.length>1 ? <AiOutlineRight className="icon" /> : false}
              </div>
              <div className="product_list">
                {val.list.length &&showChild==index? (
                  <Animated
                    animationInDuration={300}
                    animationIn="zoomIn"
                    animationOut="zoomOut"
                    isVisible={index === showChild}
                  >
                      <div className="drapBoxTwo">
                        {val.list.map((products) => {
                        return (
                          <div className="product_item">
                            <Link to={products.path}>{products.caption}</Link>
                          </div>
                        );
                      })}
                      </div>
                  
                  </Animated>
                ) : (
                  false
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default DropDown;
